import { DuplicateRow, DuplicateTag } from "./Duplicates.tsx";
import { errorParser, fetchJSON } from "../components/Loaders.ts";
import { useUIStore } from "../components/Store.ts";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getRouteApi, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useShallow } from "zustand/shallow";

const loadDuplicatesKey = (tagId: string) => ["duplicate_tags", tagId];
const loadDuplicateTags = (sessionId: string, tagId: string) => {
  const internal = async (): Promise<DuplicateTag[]> =>
    await fetchJSON<DuplicateTag[]>({
      sessionId,
      url: `/api/possible_duplicate_tags/${tagId}`,
    })
      .then((result) => result.data)
      .catch((error) => Promise.reject(errorParser("duplicate tags", error)));
  return internal;
};

function DuplicatesOneTag() {
  const queryClient = useQueryClient();
  const sessionId = useUIStore((s) => s.sessionId);
  const tagId =
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    getRouteApi("/homePathless/duplicates/$tagId").useParams().tagId! as string;

  const tagName = useUIStore(
    useShallow((s) => s.tagNames[tagId] || "loading..."),
  );
  const duplicates = useQuery({
    queryKey: loadDuplicatesKey(tagId),
    queryFn: loadDuplicateTags(sessionId, tagId),
  });

  useEffect(() => {
    document.title = `Freshet: Duplicate Tags for ${tagName}`;
  }, [tagName]);

  if (!duplicates.isSuccess) {
    return <div>Loading duplicates info...</div>;
  }
  return (
    <div id="duplicates-tab" data-testid="duplicates-tab">
      <Link to={`/Tag/${tagId}`}>Return to tag</Link>
      <br />
      <h4>
        Duplicates for <span data-testid="tag-display">{tagName}</span>
      </h4>
      <table className="table">
        <thead>
          <tr>
            <th>First</th>
            <th></th>
            <th>Second</th>
            <th></th>
            <th>Discard</th>
          </tr>
        </thead>
        <tbody>
          {duplicates.data.map((duplicate) => (
            <DuplicateRow
              key={duplicate.id}
              queryClient={queryClient}
              duplicate={duplicate}
              queryKey={loadDuplicatesKey(tagId)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default DuplicatesOneTag;
